import CSS from "./static/css/Label.module.css";
import Text from "../Text/Text";

const Label = (
    {
        is_view_essential_icon,
        children,
        is_disabled_style,
    }:{
        is_view_essential_icon?: boolean;
        children?: React.ReactNode;
        is_disabled_style?: boolean;
    }
) => {
    return(
        <Text
            class_name_list={[CSS.l_Label_main]}
            color={is_disabled_style ? "secondary" : "primary"}
            text_wrap={"nowrap"}
            is_view_essential_icon={is_view_essential_icon}
            size={"size3"}
        >
            {children}
        </Text>
    )
}

export default Label;